export default __webpack_public_path__ + "static/media/expired_article_image_placeholder.a3f56bb7.svg";